// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"eda9de0b","163":"3fd25c68","198":"7f3b28ab","261":"f15d426f","445":"70db4ca5","487":"77cadaa6","581":"04e73db5","867":"b32198d6","970":"6c3d4c50"}[chunkId] + ".chunk.js";
};